export var scales = {
    SM: "sm",
    MD: "md"
};
